import hom from '../css/Home.module.css';
import ClassCtWeb from '../components/ClassCtWeb';
import Navigation from '../components/Navigate';
import Header from '../components/Header';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { authAPI } from '../components/apiClient';
import ClassCt from '../components/ClassCt';
import scroll from "../css/scroll.module.css";
import banner from "../img/banner.png";
import cafe from "../img/cafe.svg";
import classApplyBtn from "../img/class-apply-btn.svg"
import MobileHeader from '../components/MobileHeader'
import { useMediaQuery } from 'react-responsive';;



function Home() {
  const { moveclassaply, movemypage } = Navigation();
  const location = useLocation();

  const isDesktop = useMediaQuery({ minWidth: 1024 });

  const [myClassData, setMyClassData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const [token, setToken] = useState(null);

  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [seatNum, setSeatNum] = useState('');

  const handleClick = () => {
    window.open('https://blog.naver.com/daechanyt', '_blank');  // 새 탭
  };

  const changeDate = (data) => {
    if (!data || !data.startTime) return;
    const date1 = data.startTime.slice(5, 10);
    const date2 = date1.replace('-', '.');
    setDate(date2);
    const time1 = data.startTime.slice(11, 16);
    setTime(time1);
    const seat = data.mySeatNumber.slice(5, 8)
    setSeatNum(seat);


  }

  useEffect(() => {

    const fetchMyLectures = async () => {
      try {
        const response = await authAPI.getMyReservations();

        if (response.data && response.data.length > 0) {

          const firstLecture = response.data[0];
          setMyClassData(firstLecture);
          changeDate(firstLecture);
        } else {
          setToken(true);
        }
      } catch (err) {
        console.error("내 예약 로딩 실패:", err);
      }
    };

    //전체 강의 목록 조회
    const fetchLectures = async () => {
      try {
        setLoading(true);
        const response = await authAPI.getLectureList();
        setClassData(response.data);

      } catch (err) {
        console.error("강의 목록 로딩 실패:", err);
        setError(err.response?.status || 500);
      } finally {
        setLoading(false);
      }
    };

    fetchLectures();

    const atoken = localStorage.getItem('accessToken');

    if (atoken) {
      setToken(false);
      fetchMyLectures();
    }
  }, []);



  const NoneClass = token ? hom.block : hom.none;
  const blockClass = token ? hom.none : hom.block;


  return (
    <div className={scroll.scroll}>
      <div className={scroll.scroll_section}>
        {isDesktop ? <Header /> : <MobileHeader />}
        <section className={`${hom.main_home_ct}`}>
          <div>
            <div className={hom.my_class}>
              <div className={hom.my_class_top}>
                <p>내 강의 확인</p>
              </div>

              {/* 강의 정보 없음 */}
              <div className={`${NoneClass} ${hom.none_class}`}>
                <p>강의 정보가 없습니다.</p>
                <button onClick={moveclassaply}>강의 신청 바로가기</button>
              </div>

              {/* 강의 정보 있음 */}
              <div className={`${hom.my_class_info} ${blockClass}`}>
                <div className={hom.date_time_ct}>
                  <p>{date}</p>
                  <p>{time}</p>
                  <div className={hom.gray_line}></div>
                  <p className={hom.seat_num}>{seatNum}번</p>
                </div>
                <div className={hom.class_info_div}>
                  <div className={hom.gray_ct}>수업명</div>
                  <p>
                    {myClassData.subjectName}
                  </p>
                </div>
                <div>
                  <div className={hom.gray_ct}>강사</div>
                  <p>{myClassData.instructorName}</p>
                </div>
                <button onClick={movemypage}>강의 정보 확인하기</button>
              </div>
            </div>

            <div className={hom.my_class_web}>
              <img src={banner} fetchpriority="high" />
              <button onClick={handleClick}>시대원 영통 블로그 바로가기<img src={cafe}></img></button>
            </div>

            <div className={hom.class_button_ct}>
              <button className={hom.class_apply_btn} onClick={moveclassaply}>
                <p>좌석 예약</p><img src={classApplyBtn} />
              </button>
              {/*<button className={hom.class_check_btn} onClick={moveclassaply}>
              <p>인강 신청</p>
            </button>*/}

            </div>

            <section className={hom.home_bottom}>
              <div className={hom.gray_hr}>
                <div>수강정보</div>
              </div>
              <div className={hom.class_apply_app_ct}>
                {classData.map((lecture) => (
                  <ClassCt
                    key={lecture.lectureId}
                    lectureData={lecture}
                  />
                ))}
              </div>
              <div className={hom.class_apply_web_ct}>
                {classData.map((lecture) => (
                  <ClassCtWeb
                    key={lecture.lectureId}
                    lectureData={lecture}
                    btnText="신청하기"
                  />
                ))}
              </div>
            </section>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
